import { AdminPageLayout } from "@/layouts/AdminPageLayout";
import React from "react";
import { OperationItem, OperationsList } from "../Access/OperationsList";

const items: OperationItem[] = [
  {
    title: "Modules",
    description:
      "Create and manage teaching modules, curriculum structure, and learning paths.",
    image:
      "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800",
    route: "/admin/modules",
  },
  {
    title: "Vocabulary Management",
    description:
      "Efficiently manage vocabulary sets, oversee learning progress, and update terms.",
    image:
      "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&w=800",
    route: "/admin/educational/vocabulary-management",
  },
  {
    title: "Level Tests Management",
    description: "Manage English level tests and ensure quality standards.",
    image:
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=800",
    route: "/admin/educational/level-tests-management",
  },
  {
    title: "Testes de módulo",
    description:
      "Configure the exercise pool for each module's test (create, edit, reorder).",
    image:
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=800",
    route: "/admin/educational/module-tests",
  },
];

const AdminEducationalPage: React.FC = () => {
  return (
    <AdminPageLayout title="Manage Educational">
      <OperationsList items={items} />
    </AdminPageLayout>
  );
};

export default AdminEducationalPage;
